<template>
    <div>
        <app-layout>
            <template v-slot:header>
                <Header :title="$t('internship_application')" :isFilter="false"></Header>
            </template>
            <template v-slot:header-mobile>
                <HeaderMobile :title="$t('internship_application')" :isFilter="false"></HeaderMobile>
            </template>
            <div v-if="show_warning" class="d-flex justify-content-center align-items-center" style="height:100vh">
                <b-card no-body class="overflow-hidden" style="max-width: 740px;">
                    <b-row no-gutters>
                        <b-col md="6">
                            <b-card-img :src="image" alt="Image" class="rounded-0"></b-card-img>
                        </b-col>
                        <b-col md="6">
                            <b-card-body :title="$t('internship_application').toUpper()">
                                <b-card-text>
                                    {{$t('internship_not_semester_date')}}
                                </b-card-text>
                            </b-card-body>
                        </b-col>
                    </b-row>
                </b-card>
            </div>
            <div class="row data-form" v-else>
                <div class="col-12" >
                    <ValidationObserver ref="documentForm">
                        <div class="mb-2">
                            <h6 class="mb-0">{{ $t('student_information') | toUpperCase }}</h6>
                        </div>
                        <div class="border px-5 pt-5 pb-2 mb-4 rounded">
                            <div class="row">
                                <div class="col-12 col-sm-6 col-xl-3">
                                    <b-form-group :label="$t('student_number')">
                                        {{ userData.student_number }}
                                    </b-form-group>
                                </div>
                                <div class="col-12 col-sm-6 col-xl-3">
                                    <b-form-group :label="$t('name_surname')">
                                        {{ userData.name + ' ' + userData.surname }}
                                    </b-form-group>
                                </div>
                                <div class="col-12 col-sm-6 col-xl-3">
                                    <b-form-group :label="$t('nationality')">
                                        {{ userData.nationality_code }}
                                    </b-form-group>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12 col-sm-6 col-xl-3">
                                    <b-form-group :label="$t('faculty')">
                                        {{ getLocaleText(userData,'faculty_name') }}
                                    </b-form-group>
                                </div>
                                <div class="col-12 col-sm-6 col-xl-3">
                                    <b-form-group :label="$t('program')">
                                        {{ getLocaleText(userData,'program_name') }}
                                    </b-form-group>
                                </div>
                                <div class="col-12 col-sm-6 col-xl-3">
                                    <b-form-group :label="$t('class')">
                                        {{ getLocaleText(userData,'class_name') }}
                                    </b-form-group>
                                </div>

                            </div>
                            <div class="row">
                                <div class="col-12 col-sm-6 col-xl-3">
                                    <b-form-group :label="$t('email')">
                                        {{ userData.email }}
                                    </b-form-group>
                                </div>
                                <div class="col-12 col-sm-6 col-xl-3">
                                    <b-form-group :label="$t('campus')">
                                        {{ getLocaleText(userData,'campus_name') }}
                                    </b-form-group>
                                </div>
                            </div>
                            <div class="row mt-4">
                                <div class="col-12 col-sm-4 col-md-4 col-lg-4">
                                    <ValidationProvider name="company_name" rules="required" v-slot="{valid, errors}" >
                                            <b-form-group :label="$t('company_name')">
                                                <b-form-input v-model="formData.company_name">
                                                </b-form-input>
                                                <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                                            </b-form-group>
                                    </ValidationProvider>
                                </div>
                                <div class="col-12 col-sm-4 col-md-4 col-lg-4">
                                    <ValidationProvider name="company_address" rules="required" v-slot="{valid, errors}" >
                                        <b-form-group :label="$t('company_address')">
                                            <b-form-input v-model="formData.company_address">
                                            </b-form-input>
                                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                                        </b-form-group>
                                    </ValidationProvider>
                                </div>
                                <div class="col-12 col-sm-4 col-md-4 col-lg-4">
                                    <ValidationProvider name="company_phone" rules="required" v-slot="{valid, errors}">
                                        <b-form-group :label="$t('company_phone')">
                                            <b-form-input
                                                v-model="formData.company_phone"
                                                v-mask="'(###)-###-####'"
                                                :state="errors[0] ? false : (valid ? true : null)"></b-form-input>
                                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                                        </b-form-group>
                                    </ValidationProvider>
                                </div>
                                <div class="col-12 col-sm-4 col-md-4 col-lg-4">
                                    <ValidationProvider name="responsible_name" rules="required" v-slot="{valid, errors}" >
                                        <b-form-group :label="$t('internship_manager_name')">
                                            <b-form-input v-model="formData.responsible_name">
                                            </b-form-input>
                                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                                        </b-form-group>
                                    </ValidationProvider>
                                </div>
                                <div class="col-12 col-sm-4 col-md-4 col-lg-4">
                                    <ValidationProvider name="responsible_surname" rules="required" v-slot="{valid, errors}" >
                                        <b-form-group :label="$t('internship_manager_surname')">
                                            <b-form-input v-model="formData.responsible_surname">
                                            </b-form-input>
                                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                                        </b-form-group>
                                    </ValidationProvider>
                                </div>
                                <div class="col-12 col-sm-4 col-md-4 col-lg-4">
                                    <ValidationProvider name="responsible_email" rules="required" v-slot="{valid, errors}" >
                                        <b-form-group :label="$t('internship_manager_email')">
                                            <b-form-input v-model="formData.responsible_email">
                                            </b-form-input>
                                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                                        </b-form-group>
                                    </ValidationProvider>
                                </div>
                                <div class="col-12 col-sm-4 col-md-4 col-lg-4">
                                    <ValidationProvider name="unit" rules="required" v-slot="{valid, errors}" >
                                        <b-form-group :label="$t('unit')">
                                            <b-form-input v-model="formData.unit">
                                            </b-form-input>
                                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                                        </b-form-group>
                                    </ValidationProvider>
                                </div>


                                <div class="col-12 col-sm-4 col-md-4 col-lg-4">
                                    <ValidationProvider name="day_count" rules="required" v-slot="{valid, errors}" >
                                        <b-form-group :label="$t('total_number_of_working_days')">
                                            <b-form-input v-model="formData.day_count" type="number">
                                            </b-form-input>
                                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                                        </b-form-group>
                                    </ValidationProvider>
                                </div>
                                <div class="col-12 col-sm-4 col-md-4 col-lg-4">
                                    <ValidationProvider name="internship_type" rules="required" v-slot="{valid, errors}">
                                        <b-form-group :label="$t('internship_type')">
                                            <parameter-selectbox
                                                :validate-error="errors[0]"
                                                code="internship_application.types"
                                                v-model="formData.type"
                                            ></parameter-selectbox>
                                        </b-form-group>
                                    </ValidationProvider>
                                </div>
                                <div class="col-12 col-sm-4 col-md-4 col-lg-4">
                                    <ValidationProvider name="work_status" rules="required" v-slot="{valid, errors}" >
                                        <b-form-group :label="$t('work_status')">
                                            <ParameterSelectbox  v-model="formData.working_status" :validateError="errors[0]" :code="workingStatusParameterCode"/>
                                        </b-form-group>
                                    </ValidationProvider>
                                </div>

                                <div class="col-12 col-sm-4 col-md-4 col-lg-4" v-show="['mandatory','intern'].includes(formData.type)">
                                    <ValidationProvider name="course_codes" :rules="['mandatory','intern'].includes(formData.type)?'required':''" v-slot="{valid, errors}">
                                        <b-form-group :label="$t('course_code')">
                                            <multi-selectbox v-model="formData.course_codes"
                                                             :options="coursesOptions"
                                                             :multiple="true"
                                                             :validate-error="errors[0]"
                                            ></multi-selectbox>

                                        </b-form-group>
                                    </ValidationProvider>
                                </div>
                                <div class="col-12 col-sm-4 col-md-4 col-lg-4">
                                    <ValidationProvider name="start_date" rules="required" v-slot="{ valid, errors }">
                                        <b-form-group :label="$t('start_date')">
                                            <select-date v-model="formData.start_date" key="start_date" :is-time="true" :state="errors[0] ? false : null" />
                                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]" />
                                        </b-form-group>
                                    </ValidationProvider>
                                </div>
                                <div class="col-12 col-sm-4 col-md-4 col-lg-4">
                                    <ValidationProvider name="end_date" :rules="!['work_study_student'].includes(formData.type)?'required':''" v-slot="{ valid, errors }">
                                        <b-form-group :label="$t('end_date')">
                                            <select-date v-model="formData.end_date" key="end_date" :is-time="true" :state="errors[0] ? false : null" />
                                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]" />
                                        </b-form-group>
                                    </ValidationProvider>
                                </div>
                                <div class="col-12 col-sm-4 col-md-4 col-lg-4" v-if="['work_study_student','intern', 'scholarship_recipient'].includes(formData.type)">
                                    <ValidationProvider name="iban" rules="required" v-slot="{valid, errors}">
                                        <b-form-group :label="$t('iban')">
                                            <b-form-input type="text"
                                                          v-model="formData.iban"
                                                          v-mask="['TR##-####-####-####-####-####-##']"
                                                          :state="errors[0] ? false : null">
                                            </b-form-input>
                                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                                        </b-form-group>
                                    </ValidationProvider>
                                </div>
                                <div class="col-12 col-sm-4 col-md-4 col-lg-4">
                                    <ValidationProvider name="job_description" rules="required|max:240" v-slot="{valid, errors}">
                                        <b-form-group :label="$t('job_description')">
                                            <b-form-textarea v-model="formData.job_description"
                                                             :class="errors[0] ? 'is-invalid':''"
                                                             rows="5"
                                            />
                                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"/>
                                        </b-form-group>
                                    </ValidationProvider>
                                </div>
                            </div>
                        </div>
                        <fieldset class="border p-3 mb-4 rounded bg-white shadow-sm" v-if="requiredDocuments && requiredDocuments.length>0">
                            <legend class="w-auto px-2 font-weight-bold h6">{{ $t('documents') }}</legend>
                            <b-table-simple hover small responsive class="border rounded text-center">
                                <b-thead head-variant="light">
                                    <b-tr>
                                        <b-th class="text-left font-weight-bold">{{$t('document_type')}}</b-th>
                                        <b-th class="font-weight-bold">{{ $t('status') }}</b-th>
                                        <b-th style="width: 300px;" class="font-weight-bold">{{$t('status')}}</b-th>
                                    </b-tr>
                                </b-thead>
                                <b-tbody>
                                    <b-tr v-for="(doc, index) in requiredDocuments" :key="index">
                                        <b-td class="align-middle text-left font-weight-bold">
                                            {{ getLocaleText(doc, 'name') }}
                                        </b-td>
                                        <b-td class="align-middle">
                                            <b-badge :variant="formData.documents[doc.code] ? 'success' : 'secondary'">
                                                {{ formData.documents[doc.code] ? $t('status_uploaded') : $t('status_waiting') }}
                                            </b-badge>
                                            <div v-if="formData.documents[doc.code]" class="small mt-1 text-success font-weight-bold">
                                                <i class="ri-check-line"></i> {{ $t('was_elected') }}
                                            </div>
                                        </b-td>
                                        <b-td class="align-middle text-center">
                                            <ValidationProvider :name="$t(doc.name)" rules="required" v-slot="{valid, errors}">
                                                <b-form-group :label="$t('file')">
                                                    <div class="d-flex custom-file-upload">
                                                        <b-form-file
                                                            v-model="formData.documents[doc.code]"
                                                            :state="errors[0] ? false : (valid ? true : null)"
                                                            :placeholder="$t('select_file')"
                                                            :drop-placeholder="$t('drop_file')"
                                                            :ref="'fileInput_' + index"
                                                        ></b-form-file>
                                                        <b-button variant="outline-secondary"
                                                                  @click="$refs['fileInput_' + index][0].$el.childNodes[0].click();">
                                                            {{ $t('browse') }}
                                                        </b-button>
                                                    </div>
                                                    <div class="invalid-feedback d-block" v-if="errors[0]" v-html="errors[0]"></div>
                                                </b-form-group>
                                            </ValidationProvider>
                                        </b-td>
                                    </b-tr>
                                </b-tbody>
                            </b-table-simple>
                        </fieldset>
                    </ValidationObserver>
                </div>

                <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                    <b-form-group>
                        <b-button variant="primary" @click="sendForm">{{$t('save')}}</b-button>
                    </b-form-group>
                </div>
            </div>
        </app-layout>

    </div>
</template>


<script>
import image from "@/assets/img/application-form.jpg"

    // Components
    import AppLayout from '@/layouts/AppLayout';
    import HeaderMobile from '@/layouts/AppLayout/HeaderMobile';
    import CourseAutoComplete from "@/components/interactive-fields/CourseAutoComplete";
    import {ValidationObserver, ValidationProvider} from 'vee-validate'
    import internshipApplicationService from "@/services/InternshipApplicationService";
    export default {
    components: {
        AppLayout,
        HeaderMobile,
        ValidationProvider,
        ValidationObserver,
        CourseAutoComplete
    },
    data() {
        return {
            image,
            show_warning:false,
            formData: {
                company_name: null,
                company_address: null,
                company_phone: null,
                responsible_name: null,
                responsible_surname: null,
                responsible_email: null,
                unit: null,
                day_count: null,
                course_codes: [],
                type: null,
                iban:null,
                start_date: null,
                end_date: null,
                job_description: null,
                documents: {}
            },
            userData: {
                nationality_code: null
            },
        }
    },
        async mounted() {
            await this.$store.dispatch("fetchParameter", {
                    parameterCode: "internship_application.documents" ,
                }
            );
        },
        computed: {
            requiredDocuments(){
                const documents=this.$store.getters.getParameter('internship_application.documents')
                const studentDocuments=this.userData?.documents??[]
                let selectedDocuments =[]
                if (documents.items && documents.items.length>0){
                    selectedDocuments= documents.items.filter(item=>{
                       return  studentDocuments.includes(item.code)
                    })
                }
                return selectedDocuments
            },
            coursesOptions(){
                  let options = [];
                  if (!this.userData.courses) return [];
                  options =this.userData.courses.map((course)=>{
                      return {
                          text:course,
                          value:course
                      }
                  })
                return  options
              },
            user() {
                return this.$store.getters['auth/getUser'];
            },
            workingStatusParameterCode() {
                let parameterCode='internship_application.working_statuses_mandatory'
                if (this.formData.type==='mandatory'){
                    parameterCode='internship_application.working_statuses_mandatory'
                }else if (this.formData.type==='intern'){
                    parameterCode='internship_application.working_statuses_intern'
                }else if (this.formData.type==='coop'){
                    parameterCode='internship_application.working_statuses_coop'
                }else if (this.formData.type==='work_study_student'){
                    parameterCode='internship_application.working_statuses_work_study_student'
                }else if (this.formData.type==='scholarship_recipient'){
                    parameterCode='internship_application.working_statuses_scholarship_recipient'
                }
                return parameterCode
            }
        },
    methods: {
        getData() {
            internshipApplicationService.getInternshipStudent()
                                  .then(response => {
                                      this.userData = response.data.data
                                      this.setDocuments()
                                  }).catch(error => {
                                       if (error.data.message==="SEMESTER_DATE_NOT_FOUND"){
                                           this.show_warning = true
                                       }
                                      this.showErrors(error)
                                  })
        },
        async sendForm() {
            const isValid = await this.$refs.documentForm.validate();
            if (isValid) {
                if(this.formData.type==='voluntary'){
                    delete this.formData.course_codes
                }
                const formData = new FormData();
                Object.entries(this.formData).forEach(([key, value]) => {
                    if (key==='documents') {
                        Object.entries(value).forEach(([key, value]) => {
                            formData.append(`documents[${key}]`, value);
                        })

                    }else if(key==='course_codes'){
                        this.formData.course_codes.forEach((value, key) => {
                            formData.append(`course_codes[${key}]`, value);
                        })
                    }
                    else{
                        formData.append(key, value);
                    }
                })
                internshipApplicationService.internshipApplication(formData)
                    .then(response => {
                        this.$toast.success(this.$t('application_successfully_sent'));
                        this.$router.push('/my-requests/6')
                    })
                    .catch(e => {
                        this.showErrors(e, this.$refs.documentForm);
                    });
            }
        },
        setDocuments(){
            if (this.requiredDocuments && this.requiredDocuments.length>0){
                 this.requiredDocuments.forEach((item)=>{
                     if (!this.formData.documents[item.code]){
                         this.$set(this.formData.documents, item.code, null)
                     }
                 })
            }
        },
    },
    created() {
        this.getData()
    }
}
</script>
<style>
.auto-as-parent{
    height: 100%;
    width: 100%;
}
</style>

